var v4229;
var v4230;
var v4231 = module.exports = {};
function f576() {
  throw new Error("requestAnimationFrame has not been defined");
}
function f577() {
  throw new Error("clearTimeout has not been defined");
}
(function () {
  try {
    v4229 = typeof requestAnimationFrame == "function" ? requestAnimationFrame : f576;
  } catch (e28) {
    v4229 = f576;
  }
  try {
    v4230 = typeof clearTimeout == "function" ? clearTimeout : f577;
  } catch (e29) {
    v4230 = f577;
  }
})();
function f578(p4535) {
  if (v4229 === requestAnimationFrame) {
    return requestAnimationFrame(p4535, 0);
  }
  if ((v4229 === f576 || !v4229) && requestAnimationFrame) {
    v4229 = requestAnimationFrame;
    return requestAnimationFrame(p4535, 0);
  }
  try {
    return v4229(p4535, 0);
  } catch (e30) {
    try {
      return v4229.call(null, p4535, 0);
    } catch (e31) {
      return v4229.call(this, p4535, 0);
    }
  }
}
function f579(p4536) {
  if (v4230 === clearTimeout) {
    return clearTimeout(p4536);
  }
  if ((v4230 === f577 || !v4230) && clearTimeout) {
    v4230 = clearTimeout;
    return clearTimeout(p4536);
  }
  try {
    return v4230(p4536);
  } catch (e32) {
    try {
      return v4230.call(null, p4536);
    } catch (e33) {
      return v4230.call(this, p4536);
    }
  }
}
var v4232;
var vA219 = [];
var v4233 = false;
var v4234 = -1;
function f580() {
  if (v4233 && v4232) {
    v4233 = false;
    if (v4232.length) {
      vA219 = v4232.concat(vA219);
    } else {
      v4234 = -1;
    }
    if (vA219.length) {
      f581();
    }
  }
}
function f581() {
  if (!v4233) {
    var vF578 = f578(f580);
    v4233 = true;
    for (var v4235 = vA219.length; v4235;) {
      v4232 = vA219;
      vA219 = [];
      while (++v4234 < v4235) {
        if (v4232) {
          v4232[v4234].run();
        }
      }
      v4234 = -1;
      v4235 = vA219.length;
    }
    v4232 = null;
    v4233 = false;
    f579(vF578);
  }
}
v4231.nextTick = function (p4537) {
  var vArray11 = Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var vLN173 = 1; vLN173 < arguments.length; vLN173++) {
      vArray11[vLN173 - 1] = arguments[vLN173];
    }
  }
  vA219.push(new f582(p4537, vArray11));
  if (vA219.length === 1 && !v4233) {
    f578(f581);
  }
};
function f582(p4538, p4539) {
  this.fun = p4538;
  this.array = p4539;
}
f582.prototype.run = function () {
  this.fun.apply(null, this.array);
};
v4231.title = "browser";
v4231.browser = true;
v4231.env = {};
v4231.argv = [];
v4231.version = "";
v4231.versions = {};
function f583() {}
v4231.on = f583;
v4231.addListener = f583;
v4231.once = f583;
v4231.off = f583;
v4231.removeListener = f583;
v4231.removeAllListeners = f583;
v4231.emit = f583;
v4231.prependListener = f583;
v4231.prependOnceListener = f583;
v4231.listeners = function () {
  return [];
};
v4231.binding = function () {
  throw new Error("process.binding is not supported");
};
v4231.cwd = function () {
  return "/";
};
v4231.chdir = function () {
  throw new Error("process.chdir is not supported");
};
v4231.umask = function () {
  return 0;
};